import React, { useState } from 'react';
import classnames from 'classnames';
import { getFolderCardSizeBasedOnWidth } from '@wix/da-shared-react/pkg/FolderCard/helpers';
import { GallectionType } from '@wix/da-shared-react/pkg/types/gallection';
import AddItem from '@wix/da-shared-react/pkg/AddItem';
import MediaManager from '@wix/da-shared-react/pkg/MediaPopup/MediaManager';
import { MediaSourceType } from '@wix/da-shared-react/pkg/MediaPopup/types';
import { useTranslation } from 'react-i18next';
import s from './AddNewFolderCard.scss';

export type Props = {
  width: number;
  className?: string;
  gallectionType: GallectionType;
};
export const AddNewFolderCard: React.FC<Props> = ({
  className,
  width,
  gallectionType,
}) => {
  const { t } = useTranslation();
  const [isMediaManagerShown, setShowMediaManager] = useState(false);
  const size = getFolderCardSizeBasedOnWidth(width);
  const closeMediaManagerAndReload = event => {
    setShowMediaManager(false);
    event && event.preventDefault();
    window.location.reload();
  };
  const headingTransKeys = {
    gallery: 'pages.gallections.gallery.addNew',
    collection: 'pages.gallections.collection.addNew',
  };

  return (
    <>
      <div
        className={classnames(className, s['root'], s[size])}
        style={{ width }}
      >
        <AddItem
          className={s['card']}
          title={t(headingTransKeys[gallectionType])}
          onClick={() => setShowMediaManager(true)}
        />
      </div>
      {isMediaManagerShown && (
        <MediaManager
          initialMediaSource={
            gallectionType === GallectionType.GALLERY
              ? MediaSourceType.GALLERY
              : MediaSourceType.COLLECTION
          }
          withMediaSourceSelector={false}
          withNewGallectionPopupOpen
          onDone={closeMediaManagerAndReload}
          onClose={closeMediaManagerAndReload}
        />
      )}
    </>
  );
};

AddNewFolderCard.displayName = 'AddNewFolderCard';
export default AddNewFolderCard;
